module.exports = __webpack_public_path__ + "assets/img/34_880.1ac168c5.jpg";